import { httpRequest } from "../../http";
import type { Discrepancy } from "@models/Discrepancy.model";

export class CommandAcceptDiscrepancy {
  async run(id: number, note: string): Promise<Discrepancy> {
    const url = `${import.meta.env.VITE_API_PLATFORM_SERVICE_URL}api/v1/ingest/discrepancies/${id}/accept/`;
    return httpRequest<Discrepancy, { note: string }>(url, { method: "POST", body: { note } });
  }
}
